import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';
import TaxesIncluded from 'payment-calculator/components/TaxesIncluded/TaxesIncluded.jsx';
import 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTerms/Term.scss';
import { CURRENCY_2_NO_SYMBOL } from 'commons-vehicle/constants/currencyFormats';

const Term = ({
    selectedTerm,
    term,
    handleClick,
    payment,
    paymentFrequencyLabels,
    apr,
    purchaseMethods,
    displayCreditRate,
}) => {
    const termClass = ['calculator-term', 'sr-paymentCalculator__calculatorTerm--background'];
    if (selectedTerm) {
        if (selectedTerm.term === term) {
            termClass.push('selected');
        }
    }

    return (
        <button className={termClass.join(' ')} onClick={() => handleClick(term)}>
            <div className="term">
                <div className="content">
                    <span> {term} </span>
                    {LocaleService.t('PAYMENT_CALCULATOR.TERMLABELS.MONTHS')}
                </div>
            </div>
            <div className="price is-util">
                <span className="price-highlight">{payment}</span>
                {paymentFrequencyLabels.periodically}
            </div>
            <div className="rate sr-mediumColor">
                {LocaleService.l(apr, CURRENCY_2_NO_SYMBOL)}%{displayCreditRate && ' APR'}
            </div>
            <TaxesIncluded purchaseMethods={purchaseMethods} />
        </button>
    );
};

Term.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
    paymentFrequencyLabels: PropTypes.shape({
        periodically: PropTypes.string.isRequired,
    }),
    payment: PropTypes.string.isRequired,
    term: PropTypes.number.isRequired,
    apr: PropTypes.number.isRequired,
    handleClick: PropTypes.func.isRequired,
    selectedTerm: PropTypes.instanceOf(PurchaseMethods.TermModel),
    displayCreditRate: PropTypes.bool,
};

Term.defaultProps = {
    paymentFrequencyLabels: [],
    purchaseMethods: null,
    selectedTerm: null,
    displayCreditRate: false,
};

Term.displayName = 'Term';

export default Term;
